import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { GenericAuthService, GENERIC_AUTH_SERVICE_TOKEN } from '../utils/generic-auth-service.utils';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

const API_URL_REGEX = /\/(application|analysis|admin|v\d{1}\/)/gi;

// TODO: unit tests
@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(@Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this._authService.getToken().pipe(
      switchMap((token) => {
        let requestClone = request;
        if (token && request.url.match(API_URL_REGEX)) {
          const headers: {
            [name: string]: string | string[];
          } = {};
          if (token) {
            headers['Authorization'] = `Bearer ${token}`;
          }
          if (this._authService.customerSlug) {
            headers['Nk-Customer-Slug'] = this._authService.customerSlug;
          }
          if (this._authService.sessionUuid) {
            headers['Nk-Session-UUID'] = this._authService.sessionUuid;
          }

          requestClone = request.clone({
            setHeaders: headers,
          });
        }

        return next.handle(requestClone).pipe(
          catchError((err: unknown) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                // redirect user to the logout page
              }
            }
            return throwError(() => err);
          }),
        );
      }),
    );
  }
}
